import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-herdeiro-details',
  templateUrl: './herdeiro-details.component.html',
  styleUrls: ['./herdeiro-details.component.scss']
})
export class HerdeiroDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
